import * as React from 'react';
import { NiSelect } from '@component/ant-component/select';
import { Attribute, ParameterType } from '@interface/index';
import {
  multiOperations,
  singleOperations,
  tableOperations,
  Operation,
  GetOperationName
} from '@config/index';

export interface OperationProps {
  disabled?: boolean;
  disabledOperations?: number[];
  data: number;
  isTable: boolean;
  isMultiValue: boolean;
  isFrameType?: boolean;
  onChange: (operation: number) => void;
}
export interface OperationState {
  isMultiple: boolean;
}

export const OperationComp = (props: OperationProps) => {
  const { isTable, isMultiValue, isFrameType } = props;

  return (
    <div className="Operation__wrap">
      <NiSelect
        disabled={props.disabled}
        style={{
          width: 200
        }}
        className="trigger-column__operation operation-select"
        value={`${props.data}`}
        onChange={(value: string) => {
          props.onChange(Number(value));
        }}
      >
        {(isTable ? tableOperations : (isMultiValue
          ? multiOperations
          : singleOperations)
        )
          .filter((operation: Operation) => {
            if (isFrameType) {
              return operation === Operation.RequireCondition ||
                operation === Operation.NotEmptySetCondition ||
                operation === Operation.IsTypeCondition;
            }
            return true;
          })
          .map((operation: Operation) => {

            return (
              <NiSelect.Option
                disabled={
                  (props.disabledOperations || []).indexOf(operation) !== -1
                }
                key={String(operation)}
                value={String(operation)}
              >
                {GetOperationName(operation)}
              </NiSelect.Option>
            );
          })}
      </NiSelect>
    </div>
  );
};
